import { useLocation, useSearchParams } from "wouter"

const useSearchParam = (name: string) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [currentPath, navigate] = useLocation()

  const param = searchParams.get(name)

  const setParam = (value: string) => {
    setSearchParams(
      (prev) => {
        prev.set(name, value)
        return prev
      },
      { replace: true }
    )
  }

  const clearParam = () => {
    const params = new URLSearchParams(searchParams)
    params.delete(name)
    if (!params.toString()) {
      navigate(currentPath, { replace: true })
      return
    }
    setSearchParams(params, { replace: true })
  }

  return {
    param,
    setParam,
    clearParam,
  }
}

export default useSearchParam
